import { Button, Column, Input, Modal, ModalFooter, Row, Text } from '@amzn/meridian';
import type { FC } from 'react';
import { SparkleIconWithLabel } from '../SparkleIconWithLabel';

export type PromptModalProps = {
  open: boolean;
  loading: boolean;
  productName: string;
  onNameChange: (name: string) => void;
  onCancel: () => void;
  onSubmit: (name: string) => void;
};

export const PromptModal: FC<PromptModalProps> = ({ open, loading, productName, onNameChange, onCancel, onSubmit }) => {
  if (!open) return null;

  const submit = () => onSubmit(productName.trim());

  // Save the current productName so it’s remembered when the modal closes
  const handleCancel = () => {
    onNameChange(productName);
    onCancel();
  };

  return (
    <Modal onClose={handleCancel} open title="Product Name">
      <Column>
        <Column>
          <Text>
            Please enter the public-facing name of the device featured in
            <br />
            the image (e.g. Kindle Scribe).
          </Text>
          <Text>If no device is featured, you can leave this field blank.</Text>
        </Column>
        <Input
          aria-label="Device Name"
          onChange={onNameChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !loading) {
              e.preventDefault();
              submit();
            }
          }}
          placeholder="Device Name"
          value={productName}
        />
      </Column>
      <ModalFooter>
        <Row alignmentHorizontal="end">
          <Button onClick={handleCancel} size="small" type="secondary">
            Cancel
          </Button>
          <Button disabled={loading} onClick={submit} size="small" type="primary">
            <SparkleIconWithLabel label="Generate" />
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
